import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AiFillHome } from 'react-icons/ai'
import OffersFilter from './OffersFilter'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { fetchHallsOffers, fetchStaysOffers } from '../../features/admin/placeSlice'
import PlaceCard from '../search/PlaceCard'
import Pagination from '../ui/Pagination'
import { useSEO } from '../../custom hooks/useSEO'

const Offers = () => {
    const { t } = useTranslation()  
    const { t: tSeo} = useTranslation("seo");

  const seo=useSEO({
    title: tSeo("offers.title"),
    description: tSeo("offers.description")
  });
    const [open, setOpen] = useState(true);
    const dispatch = useDispatch<AppDispatch>()
    const { user } = useSelector((state: RootState) => state.user);
    const { hallsOffer, staysOffer, pagination } = useSelector((state: RootState) => state.placeSlice);
    const [filters, setFilters] = useState({
        categoryId: 1,
        subCategoryId: 0,
        rate: 0,
        services: [] as number[],
    })
    useEffect(() => {
        if (filters.categoryId === 1) {
            dispatch(fetchStaysOffers({ userId: user?.id, page: 1 }));
        } else if (filters.categoryId === 4) {
            dispatch(fetchHallsOffers({ userId: user?.id, page: 1 }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters.categoryId, user?.id]);

    const filteredOffers = useMemo(() => {
        const offers = filters.categoryId === 1 ? staysOffer : filters.categoryId === 4 ? hallsOffer : [];

        return offers.filter((offer: any) => {
            // SubCategory filter
            if (filters.subCategoryId && offer.subCategory?.id !== filters.subCategoryId) return false;


            // Rating filter
            if (filters.rate && offer.rate !== Number(filters.rate)) return false;

            // Services filter (check if all selected services exist in offer.services)
            if (filters.services.length > 0) {
                const offerAmenityIds = (offer.amenities || []).map((s: any) => s.id);
                const hasAll = filters.services.every((serId) => offerAmenityIds.includes(serId));
                if (!hasAll) return false;
            }

            return true;
        });
    }, [filters, staysOffer, hallsOffer]);
    return (
        <div>
            {seo}
            <div className="green-hero flex-center relative main-prop xs:h-full md:h-[70vh] padding-container">
                <div className="relative z-20 text-white text-center py-10">
                    <h1 className="text-4xl font-bold mb-2">{t("offers")}</h1>
                    <div className="flex items-center justify-center gap-1 text-base">
                        <AiFillHome className="mr-1 text-white text-lg" />
                        <span>{t('home')}</span>
                        <span className="mx-2">/</span>
                        <span>{t("offers")}</span>
                    </div>
                </div>
            </div>
            <div className=' padding-container main-prop'>
                <div className='grid relative gap-5 xs:grid-cols-1 md:grid-cols-4'>
                    <div className={`${open ? "" : "xs:hidden md:col-span-1"} h-fit md:col-span-1 md:block`}>
                        <OffersFilter openFilter={open} setOpenFilter={setOpen} filters={filters} setFilters={setFilters} type={"Stay"} />
                    </div>
                    <div className='col-span-3 space-y-4'>
                        <div>
                            <div className=' space-y-3'>
                                {filteredOffers.map((offer: any) => (
                                <div key={offer.id} className='w-full'>
                                    <PlaceCard place={offer} />
                                </div>
                            ))} 
                            </div>
                            <Pagination
                                currentPage={pagination?.currentPage || 1}
                                lastPage={pagination?.lastPage || 1}
                                onPageChange={(page) => {
                                    if (filters.categoryId === 1) {
                                        dispatch(fetchStaysOffers({ userId: user?.id, page }));
                                    } else if (filters.categoryId === 4) {
                                        dispatch(fetchHallsOffers({ userId: user?.id, page }));
                                    }
                                }}
                            />
                        </div>

                        {filteredOffers.length === 0 && (
                            <div className=' w-full h-full flex-center flex-col text-center'>
                                <img src="/asset/empty.png" alt="" />
                                <p>{t("no-offers-here")}</p>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Offers